import {
  isValidPhoneNumber,
  parsePhoneNumber,
  type Country,
} from 'react-phone-number-input';

export const phonenumberToE164 = ({
  phonenumber,
  countryCode,
}: {
  phonenumber?: string;
  countryCode?: Country | string;
}): string | null => {
  if (!phonenumber) {
    return null;
  }
  if (phonenumber.startsWith('+') && isValidPhoneNumber(phonenumber)) {
    return phonenumber;
  }
  return parsePhoneNumber(phonenumber, countryCode as Country)?.number ?? null;
};
